import type { ParseKeys } from 'i18next';
import type { MiceOrderStatus } from '@voll-intelligence/domain';
import { t } from '@web/i18n';
import { ToneChip, type ToneChipTone } from '@web/ui/core';

const TONE = {
  validating: 'gray',
  invalid: 'red',
  duplicate: 'gray',
  ready: 'brand',
  queued: 'ai',
  purchasing: 'ai',
  awaiting_approval: 'amber',
  awaiting_issuance: 'amber',
  issued: 'green',
  failed: 'red',
  indeterminate: 'red',
} as const satisfies Record<MiceOrderStatus, ToneChipTone>;

const STATUS_KEY = {
  validating: 'mice.status.validating',
  invalid: 'mice.status.invalid',
  duplicate: 'mice.status.duplicate',
  ready: 'mice.status.ready',
  queued: 'mice.status.queued',
  purchasing: 'mice.status.purchasing',
  awaiting_approval: 'mice.status.awaiting_approval',
  awaiting_issuance: 'mice.status.awaiting_issuance',
  issued: 'mice.status.issued',
  failed: 'mice.status.failed',
  indeterminate: 'mice.status.indeterminate',
} as const satisfies Record<MiceOrderStatus, ParseKeys>;

export function OrderStatusChip({
  status,
}: Readonly<{ status: MiceOrderStatus }>): React.JSX.Element {
  return <ToneChip tone={TONE[status]}>{t(STATUS_KEY[status])}</ToneChip>;
}
